import React, { useContext, useEffect, useState } from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CardComponent } from '../CardComponent';
import { deleteCurrentMessage, getCurrentMessage } from '../../services/cloudFirestore';
import { UserContext } from '../../providers/UserProvider';
import { MessagesDeProducteurs } from '../../models/MessagesDeProducteurs';
import { convertSecondsToHours } from '../../utils';
import { DeleteModal } from '../DeleteModal';
import { StyledDashboardHeading, StyledRowBox } from '../../theme/StyledElements';
import { MessageTimerComponent } from '../Message/MessageTimerComponent';
import { MessageDescriptionComponent } from '../Message/MessageDescriptionComponent';
import { useMountedRef } from '../../hooks/useMountedRef';

const StyledMessageBoxBody = styled(StyledRowBox)(() => ({
    alignItems: 'center',
    marginLeft: '-225px'
}));

const StyledMessageHeading = styled(StyledDashboardHeading)(() => ({
    margin: '40px 0px 20px -230px'
}));

export function Message(): React.ReactElement {
    const { t } = useTranslation();
    const mounted = useMountedRef();
    const user = useContext(UserContext);
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [timer, setTimer] = useState<number[]>([]);
    const [messageData, setMessageData] = useState<MessagesDeProducteurs>({
        idMessagesDeProducteur: undefined,
        idProducteur: undefined,
        titre: undefined,
        description: undefined,
        numberOfViews: undefined,
        photos: undefined,
        createdDate: undefined
    });

    useEffect(() => {
        if (user && user.idProducteur && mounted.current) {
            getCurrentMessage(user.idProducteur).then((data) => {
                if (data && data.createdDate && mounted.current) {
                    setMessageData(data);
                    setTimer(convertSecondsToHours(data.createdDate));
                }
            });
        }
    }, []);

    const deleteMessage = async (): Promise<void> => {
        if (messageData.idMessagesDeProducteur) {
            await deleteCurrentMessage(messageData.idMessagesDeProducteur);
            window.location.reload();
        }
    };

    return (
        <>
            {messageData.idMessagesDeProducteur && (
                <Box>
                    <DeleteModal
                        isModelOpen={openDeleteModal}
                        setModelOpen={setOpenDeleteModal}
                        title={t('deleteMessage')}
                        description1={t('confirmDeleteMessage1')}
                        description2={t('confirmDeleteMessage2')}
                        onCancelClick={(): void => {
                            setOpenDeleteModal(false);
                        }}
                        onDeleteClick={(): void => {
                            setOpenDeleteModal(false);
                            deleteMessage();
                        }}
                    />
                    <StyledMessageHeading variant="h3">
                        {t('yourCurrentMessage')}
                    </StyledMessageHeading>
                    <StyledMessageBoxBody>
                        <CardComponent cardStyle={{ height: 'auto' }}>
                            <MessageTimerComponent
                                timer={timer}
                                onDeleteClick={(): void => setOpenDeleteModal(true)}
                            />
                        </CardComponent>
                        <MessageDescriptionComponent messageData={messageData} user={user} />
                    </StyledMessageBoxBody>
                </Box>
            )}
        </>
    );
}
